import { Route, Routes } from "react-router-dom";
// import { Navbar } from "./components/Navbar";
import { Karmashree_logo } from "./components/Logo";
import "./App.css";
import { Suspense, lazy } from "react";
import { sideBarList } from "./components/Sidebar";
// import { ConfirmUser, ResetPassword } from "./views/ResetPassword";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingPage from "./views/forms/LoadingPage";

// import Home from "./views/Home";
// import Auth from "./auth/Auth";
// import Login from "./views/Login";
// import Contact from "./views/Contact";
// import Dashboard from "./views/Dashboard";
// import Profile from "./views/forms/Profile";
// import OTPConfirm from "./views/OtpConfirm";
// import ViewProfile from "./views/forms/ViewProfile";
// import Edit from "./components/Edit";
// import Dno from "./views/forms/Dno";
// import Error404 from "./views/Error404";
// import ActionPlanReport1 from "./views/reports/ActionPlanReport1";
// import ActionPlanReport3 from "./views/reports/ActionPlanReport3";
// import ActionPlanReport2 from "./views/reports/ActionPlanReport2";
// import WorkAllocationView from "./views/forms/WorkAllocationView";
// import SchemeEdit from "./views/forms/SchemeEdit";
// import SchemeView from "./views/forms/SchemeView";
// const Home = lazy(() => import("./views/Home"));
// const Auth = lazy(() => import("./auth/Auth"));
// const Login = lazy(() => import("./views/Login"));
// const Contact = lazy(() => import("./views/Contact"));
const Dashboard = lazy(() => import("./views/Dashboard"));
// const Profile = lazy(() => import("./views/forms/Profile"));
// const OTPConfirm = lazy(() => import("./views/OtpConfirm"));
// const ViewProfile = lazy(() => import("./views/forms/ViewProfile"));
const Edit = lazy(() => import("./components/Edit"));
// const Dno = lazy(() => import("./views/forms/Dno"));
const Error404 = lazy(() => import("./views/Error404"));
// const ActionPlanReport1 = lazy(() =>
//   import("./views/reports/ActionPlanReport1")
// );
// const ActionPlanReport3 = lazy(() =>
//   import("./views/reports/ActionPlanReport3")
// );
// const ActionPlanReport2 = lazy(() =>
//   import("./views/reports/ActionPlanReport2")
// );
// const WorkAllocationView = lazy(() =>
//   import("./views/forms/WorkAllocationView")
// );
// const UserManual = lazy(() => import("./views/UserManual"))
// const ManualEdit = lazy(() => import("./views/UsermanualEdit"));
// const SchemeEdit = lazy(() => import("./views/forms/SchemeEdit"));
// const SchemeView = lazy(() => import("./views/forms/SchemeView"));
// import { useNetworkState } from "@uidotdev/usehooks";
function App() {
  // const network = useNetworkState();


  return (
    <>
      <ToastContainer />
      <Routes>


        {sideBarList.map(({ route, Component, text }) => {
          return (
            <Route
              key={text}
              path={route}
              element={

                <Dashboard>
                  <Suspense
                    fallback={
                      <div className="flex items-center justify-center flex-grow p-8 px-12">
                        <Karmashree_logo className="fill-blue-400 h-[10rem] animate-pulse w-fit" />
                      </div>
                    }
                  >
                    <Component />
                  </Suspense>
                </Dashboard>

              }
            />
          );
        })}
        <Route
          path="/"
          element={
            <Suspense>
              <LoadingPage />
            </Suspense>
            }
        />
        <Route
          path={"/profile-edit"}
          element={

            <Dashboard>
              <Suspense>
                {/* <Profile /> */}
              </Suspense>
            </Dashboard>

          }
        />
        <Route
          path={"/edit/:userId"}
          element={

            <Dashboard>
              <Suspense>
                <Edit />
              </Suspense>
            </Dashboard>

          }
        />

        <Route
          path="*"
          element={
            <Suspense>
              <Error404 />
            </Suspense>
          }
        />
      </Routes>
    </>
  );
}

export default App;
